import React from 'react';
import { ListGroup } from 'react-bootstrap';
import { Building } from '../../types/protocols';
import { getEventTypeLabel, getEventColor } from '../../types/timeline';
import { useComponentTimelineEvents, ConnectedTimelineEvent } from '../../hooks/components/useComponentTimelineEvents';

interface ComponentConnectedEventsProps {
    building: Building;
    componentKey: string;
}

// Storage format is "YYYY-MM-DD hh:mm:ss"; year-only events show just the year.
const formatEventDate = (event: ConnectedTimelineEvent): string =>
    event.inexactDate ? event.displayDate.substring(0, 4) : event.displayDate.substring(0, 10);

/**
 * Lists timeline events connected to a component ("Anslutna händelser"). Renders
 * nothing while loading or when there are no connected events, so the section
 * never appears empty.
 */
const ComponentConnectedEvents: React.FC<ComponentConnectedEventsProps> = ({ building, componentKey }) => {
    const { events } = useComponentTimelineEvents(building, componentKey);

    if (events.length === 0) {
        return null;
    }

    return (
        <div style={{ marginTop: '30px' }}>
            <h4 style={{ marginBottom: '15px' }}>Anslutna händelser</h4>
            <ListGroup>
                {events.map((event) => (
                    <ListGroup.Item
                        key={event.id}
                        className="d-flex justify-content-between align-items-center"
                    >
                        <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={{
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                            }}>
                                {event.title}
                            </div>
                            <small style={{ color: '#666' }}>{formatEventDate(event)}</small>
                        </div>
                        <span
                            className="badge"
                            style={{
                                backgroundColor: getEventColor(event.eventType),
                                color: 'white',
                                fontWeight: 500,
                            }}
                        >
                            {getEventTypeLabel(event.eventType)}
                        </span>
                    </ListGroup.Item>
                ))}
            </ListGroup>
        </div>
    );
};

export default ComponentConnectedEvents;
